export default "__VITE_ASSET__Bqlh0I0R__"